import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import InputBase from "@mui/material/InputBase";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function ConfiguracionLicencias() {
const [licencias, setLicencias] = useState([]);
const [loading, setLoading] = useState(true);

// Lógica lista para conectarse con endpoint en el futuro
useEffect(() => {
const fetchLicencias = async () => {
try {
// Aquí se conectará el endpoint, por ejemplo:
// const response = await fetch("/api/licencias");
// const data = await response.json();
// setLicencias(data);


    // Por ahora sin datos (vacío)
    setLicencias([]);
  } catch (error) {
    console.error("Error al cargar las licencias:", error);
  } finally {
    setLoading(false);
  }
};

fetchLicencias();

}, []);

return ( <DashboardLayout> <DashboardNavbar /> <MDBox pt={6} pb={3}> <Grid container spacing={6}> <Grid item xs={12}>
<Card sx={{ borderRadius: "20px", overflow: "hidden" }}>
<MDBox
px={3}
py={2}
display="flex"
justifyContent="space-between"
alignItems="center"
sx={{
background: "linear-gradient(90deg, #9900b8ff 0%, #9900b8ff 100%)",
flexWrap: "wrap",
gap: 2,
}}
>
<MDButton
variant="contained"
sx={{
backgroundColor: "white",
color: "#9900b8ff",
fontWeight: "bold",
borderRadius: "12px",
textTransform: "none",
"&:hover": { backgroundColor: "#f5f5f5" },
}}
>
<Icon sx={{ fontSize: 18, mr: 0.5 }}>add</Icon> Nueva Licencia </MDButton>


            <MDTypography
              variant="h6"
              color="white"
              sx={{
                textAlign: "center",
                flexGrow: 1,
                fontWeight: "bold",
                fontSize: "1.2rem",
              }}
            >
              Configuración de las Licencias
            </MDTypography>

            <MDBox
              component="form"
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                borderRadius: "30px",
                px: 2,
                py: 0.5,
                width: "260px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
              }}
            >
              <Icon fontSize="small" sx={{ color: "#777" }}>
                search
              </Icon>
              <InputBase placeholder="Buscar Empresa..." sx={{ ml: 1, flex: 1 }} />
            </MDBox>
          </MDBox>

          {/* Tabla */}
          <MDBox p={3}>
            {loading ? (
              <MDTypography variant="body2" color="text">
                Cargando licencias...
              </MDTypography>
            ) : licencias.length === 0 ? (
              <MDTypography variant="body2" color="text">
                No hay licencias registradas.
              </MDTypography>
            ) : (
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="left"><strong>Nombre de la Licencia</strong></TableCell>
                    <TableCell align="center"><strong>Tipo Paquete</strong></TableCell>
                    <TableCell align="center"><strong>Cantidad</strong></TableCell>
                    <TableCell align="center"><strong>Precio</strong></TableCell>
                    <TableCell align="center"><strong>Destinatario</strong></TableCell>
                    <TableCell align="center"><strong>Acciones</strong></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {licencias.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">{row.nombre}</TableCell>
                      <TableCell align="center">{row.paquete}</TableCell>
                      <TableCell align="center">{row.cantidad}</TableCell>
                      <TableCell align="center">{row.precio}</TableCell>
                      <TableCell align="center">{row.destinatario}</TableCell>
                      <TableCell align="center">
                        <Icon color="success" sx={{ cursor: "pointer", mr: 1, fontSize: 20 }}>
                          edit
                        </Icon>
                        <Icon color="info" sx={{ cursor: "pointer", fontSize: 22 }}>
                          toggle_on
                        </Icon>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </MDBox>
        </Card>
      </Grid>
    </Grid>
  </MDBox>
  <Footer />
</DashboardLayout>

);
}

export default ConfiguracionLicencias;
